import React from 'react'

import Card from '@mui/material/Card';
import { Divider } from '@mui/material';

const EditorGuidlines = () => {
    return (
        <>
            <Card>
                <div className="row">
                    <div className="col-12 p-3 text-center">
                        <h3>EDITOR GUIDLINES</h3>
                    </div>
                </div>
            </Card>
            <Divider />

            <Card>
                <div className="row">
                    <div className="col-md-12 p-4 m-2 px-5">
                        <p>

                            Editorial Board Members Role and Responsibilities
                        </p>

                        <p>

                            The editorial board, sometimes known as the (editorial) advisory committee, is a team of individuals in the journal’s field. Some individuals may also belong to the editorial boards of other journals.
                        </p>

                        <p>

                            o Expertise in subject matter.
                            <br />
                            o Reviewing submitted manuscripts.
                            <br />
                            o Advising on journal policy and scope.
                            <br />
                            o Identifying subjects and conferences for special issues which they might also help to organize and/or guest edit.
                            <br />
                            o Attracting new authors and submissions.
                            <br />
                            o Ideally submitting some of their own work for consideration.
                            <br />
                            o To ensure a supply of high-quality manuscripts to the Publishing House (ISSRA) in quantities that can maintain the publishing schedule of the journal; if insufficient manuscripts are being submitted, then you should discuss how to address this with your publishing contact.
                            <br />
                            o To keep vision that the subject matter of the manuscripts reflects any changes of direction in the field of study to incorporate newly-emerging work; this may necessitate inviting articles or special issues.
                            <br />
                            o Give suggestion in selection of the editorial board, in co-operation with your publishing contact.
                            <br />
                            o Continually engage the editorial board on the progress of the journal and update and include them on ideas for editorial development. The editorial board should be involved formally through an annual editorial board meeting or informally in ad hoc meetings and discussions.
                            <br />
                            o To provide strategic input into the journal’s development. The publishing contact will be in touch regularly to report on the journal’s performance and suggest possible strategies for development, as well as discuss your suggestions.
                            <br />
                            o Encouragement in highlighting commercial advertising, supplement, and reprint opportunities, if these forms act as important sources of revenue generation for the journal.
                            <br />
                            o Promotion of the journal among peers and colleagues.
                            <br />
                        </p>

                        <p>

                            Due to enormous number of submissions and the scope of the journal being broad it might not possible for one editor to make informed decisions about submissions in all subject areas. So categorically referred
                        </p>

                        <p>


                            1. Editor-in-chief.
                            <br />
                            2. Co-Editors.
                            <br />
                            3. Associate Editors.
                            <br />
                            4. Section Editors.
                            <br />
                            5. Editorial Advisor.
                            <br />
                            6. External Editors.
                            <br />
                            7. Guest Editors.

                        </p>

                    </div>
                </div>
            </Card>
        </>
    )
}

export default EditorGuidlines;